import {FC, ComponentProps} from 'react'
import {useController, useFormContext} from 'react-hook-form'
import moment, {Moment} from 'moment'
import {DateField as UncontrolledDateField} from 'components/forms/DateField'
// @ts-ignore
import * as validators from 'jbc-front/utils/validators'

// @ts-ignore
import {toAdYearDate, toJpYearDate} from 'jbc-front/utils/jpYear'

type DateFieldProps = ComponentProps<typeof UncontrolledDateField> & {
  name: string
  displayJpDate?: boolean
}

const isValidDate = (value: string) =>
  value && moment(value, 'YYYY/MM/DD').isValid() && value.match(validators.adYearRegExp)

const jpYearDate = (value: string) => {
  const dateMatch = value.match(validators.adYearRegExp)
  if (dateMatch && moment(value, 'YYYY/MM/DD').isValid()) {
    const date = new Date(Number(dateMatch[1]), Number(dateMatch[2]) - 1, Number(dateMatch[3]))
    return toJpYearDate(date)
  }
  return null
}

export const DateField: FC<DateFieldProps> = ({name, displayJpDate = true, ...dateFieldProps}) => {
  const {control} = useFormContext()
  const {field} = useController({
    name,
    control,
  })

  const handleChange = (value: string | Moment) => {
    if (typeof value === 'string') {
      field.onChange(value)
    } else {
      field.onChange(value.format('YYYY/MM/DD'))
    }
  }

  const handleClose = () => {
    if (!isValidDate(field.value)) {
      const adYearDate = toAdYearDate(field.value)

      if (adYearDate) {
        field.value = adYearDate
        field.onChange(adYearDate)
      }
    }
    field.onBlur()
  }

  const inputProps = {
    value: field.value,
    display: displayJpDate && jpYearDate(field.value),
  }

  return (
    <UncontrolledDateField
      {...dateFieldProps}
      initialValue={field.value}
      onChange={handleChange}
      onClose={handleClose}
      inputProps={inputProps}
    />
  )
}
